export default {
  contactContent: {
    address: "العنوان",
    phone: "رقم الهاتف",
    email: "البريد الإلكتروني",

    addressText:
      "16/A، برج رومدان سيتي \nنيويورك، الولايات المتحدة",

    formTitle: "إرسال طلب مورد",

    name: "اسمك",
    emailPlaceholder: "البريد الإلكتروني",
    phonePlaceholder: "رقم الهاتف",
    subject: "الموضوع",
    message: "ابدأ المحادثة",

    submit: "إرسال الطلب",
  },
};